import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormControl, FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { fromEvent, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ListColumn } from './list-column.model';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
// Depending on whether rollup is used, moment needs to be imported differently.
// Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// syntax. However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment } from 'moment';
import { nullCheckValidator } from '../utils/calsoft-validators';
import { LeadStatusService } from 'src/app/services/lead-status.service';
import { Router, NavigationEnd } from '@angular/router';
import { LeadSourceService } from 'src/app/services/lead-source.service';
import { UsersService } from 'src/app/services/users.service';
import { AnyNode } from 'postcss';
import { PaymentTypeService } from 'src/app/services/payment-type.service';
import { PoswarehouseService } from 'src/app/services/poswarehouse.service';
import { PosSupplierService } from 'src/app/services/pos-supplier.service';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { DealsStageService } from 'src/app/services/deals-stage.service';
import { Constant } from 'src/app/constant/constant';
import { MatDialog } from '@angular/material/dialog';
import { CrmBusinessEditComponent } from '../crm-business-edit/crm-business-edit.component';
import { TagesStatusService } from 'src/app/services/tages-status.service';
import { PriorityService } from 'src/app/services/priority.service';
import { TrackerService } from 'src/app/services/tracker.service';
import { StatusService } from 'src/app/services/status.service';
import { TaskStatusService } from 'src/app/services/task-status.service';
import { IndustryTypeService } from 'src/app/services/industry-type.service';
import { BussinessTypeService } from 'src/app/services/bussiness-type.service';
import { BrandService } from 'src/app/services/brand.service';
import { CategoriesService } from 'src/app/services/categories.service';

const moment = _rollupMoment || _moment;

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL'
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY'
  }
};;

@Component({
  selector: 'calsoft-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})



export class ListComponent implements OnInit, OnChanges, OnDestroy {

  filteredBrandTypeList: any;
  brandTypeList: any;
  brandList: any;
  BrandFilterControl: UntypedFormControl = new UntypedFormControl();

  filteredCategoryTypeList: any;
  categoryTypeList: any;
  categoryList: any;
  CategoryFilterControl: UntypedFormControl = new UntypedFormControl();

  sanitizedUrl: string = '';

  url = '';


  @Input() filterSelectObj: any = [];

  @Input() name: string;

  @Input() progress: any;

  @Input() leadFilterType: any = 1;
  @Input() filterType: any;
  @Input() gridType: any;
  @Input() GridType: any;

  leadFilterType1: any = 0;

  @Input() type: any = 1;
  @Input() ChartType: any = 0;

  @Input() disableFilter: any = 0;

  @Input() displayFilerOption: any = false;
  @Input() columns: ListColumn[];
  @ViewChild('filter', { static: true }) filter: ElementRef;
  @Output() filterChange = new EventEmitter<string>();
  value = new UntypedFormControl('');
  @Input() searchRequired;


  @Input() refreshRequired = false;

  @Input() displayColumnRequired: any;


  @Output() filterChangeColumn = new EventEmitter<any>();


  @Output() filterChangeColumnNew = new EventEmitter<any>();
  firstValue: any = null;
  secondValue: any = null;
  thirdValue: any = null;
  fourthValue: any = null;
  searchTerm: string = undefined;
  selected = 'ALL';
  searchValues: any;
  index: any;
  j: any;
  searchTermPresent: any = true;
  searchTermMain: any;
  searchTermMainEmit: any = 0;
  searchTermEmit: any = 0;
  searchTermMainPresent: any = true;
  rangeEnable: boolean = false;
  filterOpen: boolean = true;

  @Input() sirType = false;
  @Input() hideOthers = false;

  isPopupOpen: boolean;
  popupType: number;
  crmSettingsData: any;
  configData: any;
  editBusiness: boolean = false;

  constructor(public datepipe: DatePipe,
    private _formBuilder: UntypedFormBuilder,
    private poswarehouseService: PoswarehouseService,
    private leadStatusService: LeadStatusService,
    private leadSourceService: LeadSourceService,
    private taskStatusService: TaskStatusService,
    private ecryptService: EcryptServiceService,
    private router: Router,
    private usersService: UsersService,
    private paymentTypeService: PaymentTypeService,
    private posSupplierService: PosSupplierService,
    private dealsStageService: DealsStageService,
    public dialog: MatDialog,
    private tagesStatusService: TagesStatusService,
    private priorityService: PriorityService,
    private trackerService: TrackerService,
    private statusService: StatusService,
    private cdr: ChangeDetectorRef,
    private industryTypeService: IndustryTypeService,
    private bussinessTypeService: BussinessTypeService,
    private brandService: BrandService,
    private categoriesService: CategoriesService,
  ) {
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }
  selectedValuesDate: { [key: string]: any } = {};


  range: UntypedFormGroup;
  init: boolean = false;

  displayOwner: boolean = false;

  get isGridTypeOneToSeven(): boolean {
    const val = Number(this.gridType ?? this.GridType ?? this.configData?.gridType ?? this.configData?.gridtype ?? 0);
    return val >= 1 && val <= 7;
  }

  ngOnInit() {

    let val = parseInt(localStorage.getItem(Constant.SU))

    let userType: any = localStorage.getItem(Constant.Sup);

    if (isNaN(val)) {
      val = 0;
    }

    if (val > 0 || userType === 'Sales User') {

      this.displayOwner = true;

    } else {
      this.displayOwner = false;
    }

    if (this.displayOwner) {

      console.log(val);

      let index = this.filterSelectObj.findIndex(x => x.property == 'ownerEmail');

      if (index > 0) {
        this.filterSelectObj.splice(index, 1);
      } else {

      }

    }

    let filter: any;


    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encrypted);
        this.crmSettingsData = JSON.parse(decrypted);
        // console.log("CRM Settings Data:", this.crmSettingsData);
      } catch (err) {
        console.error("Error decrypting crmSettingsData", err);
      }
    }

    const encryptedConfig = localStorage.getItem('configSettingsData');
    if (encryptedConfig) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedConfig);
        if (decrypted) {
          this.configData = JSON.parse(decrypted);
          // console.log("Config Settings Data:", this.configData);
          this.leadFilterType1 = this.filterType ?? this.leadFilterType ?? this.configData?.filterType;
          if (this.leadFilterType1 == 6) {
            this.type = 1;
          }

          if (this.leadFilterType1 == 4 || this.leadFilterType1 == 7) {
            this.filterOpen = false;
          }
        }
      } catch (err) {
        console.error("Error decrypting configSettingsData", err);
      }
    }

    let url = this.router.url;
    this.initializeForm();
    if (filter != undefined) {

      if (this.leadFilterType1 == 4 || this.leadFilterType1 == 7) {
        this.filterOpen = false
      }
    }

    if (this.router.url == 'lead') {
      this.editBusiness = true;
    } else if (this.router.url == 'deals') {
      this.editBusiness = true;
    } else if (this.router.url == 'companies') {
      this.editBusiness = true;
    }

    let cleanUrl = url.split('?')[0];
    let range: any = JSON.parse(localStorage.getItem(cleanUrl + "range"))
    let filterObject = [];
    const stored = localStorage.getItem(cleanUrl + 'selectedDate');
    if (stored) {
      try {
        this.selectedValuesDate = JSON.parse(stored) || {};
      } catch (e) {
        console.error('Error parsing stored data', e);
        this.selectedValuesDate = {};
      }
    }



    filterObject = JSON.parse(localStorage.getItem(cleanUrl))
    let searchTerm = localStorage.getItem(cleanUrl + "se")
    let type = localStorage.getItem(cleanUrl + "type")
    if (filterObject == null) {
      filterObject = [];
    } else {
      this.filterSelectObj = filterObject;

    }

    if (type == "2" && this.filterSelectObj.length > 0 && searchTerm != null) {


      let selected: any = null;
      try {
        selected = JSON.parse(localStorage.getItem(cleanUrl + "selected"));
      } catch (e) {
        // ignore JSON parse errors; we'll try to handle as string below
        selected = localStorage.getItem(cleanUrl + "selected");
      }

      if (selected != null) {
        this.selectedValues = selected;
      }

      // Support legacy storage key 'select' which may contain a stringified object
      const rawSelect = localStorage.getItem(cleanUrl + 'select');
      if (rawSelect) {
        const parseFallback = (raw: string) => {
          // try JSON
          try {
            return JSON.parse(raw);
          } catch (_e) {
            const map: any = {};
            const regex = /([\w\.\- ]+)\s*[:=]\s*(\[[^\]]*\]|"[^"]*"|'[^']*'|[^,;]+)/g;
            let m: RegExpExecArray | null;
            while ((m = regex.exec(raw)) !== null) {
              const key = m[1].trim();
              let val = m[2].trim();
              if ((val.startsWith('"') && val.endsWith('"')) || (val.startsWith("'") && val.endsWith("'"))) {
                val = val.slice(1, -1);
              }
              if (val.startsWith('[') && val.endsWith(']')) {
                const inner = val.slice(1, -1).trim();
                map[key] = inner.length ? inner.split(/\s*,\s*/).map(v => v.replace(/^['"]|['"]$/g, '').trim()) : [];
              } else if (val.indexOf('|') !== -1) {
                map[key] = val.split('|').map((v: string) => v.trim());
              } else if (val.indexOf(',') !== -1) {
                map[key] = val.split(',').map((v: string) => v.trim());
              } else {
                map[key] = val;
              }
            }
            return map;
          }
        };

        try {
          const selectParsed = parseFallback(rawSelect);
          if (selectParsed && typeof selectParsed === 'object') {
            Object.keys(selectParsed).forEach(k => {
              const val = selectParsed[k];
              const idx = this.filterSelectObj.findIndex((f: any) => f.property === k || f.name === k || f.property === k.trim());
              if (idx > -1) {
                const element = this.filterSelectObj[idx];
                if (element.type === 'multiSelect') {
                  const arr = Array.isArray(val) ? val : (typeof val === 'string' ? val.split(/\s*,\s*|\|/).map((v: string) => v.trim()) : []);
                  this.selectedValues[idx] = arr;
                  try { this[element.position] = arr; } catch (e) { }
                } else if (element.type === 'select') {
                  const v = Array.isArray(val) ? val[0] : val;
                  this.selectedValues[idx] = v;
                  try { this[element.position] = v; } catch (e) { }
                } else if (element.type === 'date') {
                  try { this[element.position] = val; this.selectedValuesDate[element.position] = val; } catch (e) { }
                } else {
                  element.modelValue = val;
                  try { this[element.position] = val; } catch (e) { }
                }
              }
            });
          }
        } catch (err) {
          // ignore parse errors for legacy select
        }
      }

      let indexValue = 0;

      this.filterSelectObj.forEach(element => {

        if (searchTerm == null || searchTerm == undefined || searchTerm == '') {

          element.modelValue = '';
        }


        if (filterObject[indexValue] && filterObject[indexValue].modelValue !== undefined) {
          element.modelValue = filterObject[indexValue].modelValue;
        }

        if (element.type == 'multiSelect') {
          console.log(element);

          this[element.position] = this.selectedValues[indexValue];

          console.log(this[element.position]);
        }


        if (element.type == 'date') {
          this[element.position] = this.selectedValuesDate[element.position];
        }


        indexValue++;
      });
      this.searchTerm = searchTerm;
      this.searchTermPresent = false;
      this.cdr.markForCheck();
    }

    if (type == "1" && searchTerm != null) {
      this.filter.nativeElement.value = searchTerm;

      this.refreshRequired = false;
    }

    if (searchTerm == undefined) {

      this.filterSelectObj.forEach(element => {
        element.modelValue = '';


      });


    }


    let indexForLocation = this.filterSelectObj.findIndex(x => x.name == 'Location' || x.name == 'Warehouse' || x.name == 'Warehouse Name' || x.property == 'warehouse' || x.property == 'warehouseName')
    if (indexForLocation > -1) {
      this.getAllWareHouseList();
    }
    let indexForSuppliers = this.filterSelectObj.findIndex(x => x.name == 'Suppliers' || x.name == 'Supplier')
    if (indexForSuppliers > -1) {
      this.getAllSupplierList();
    }


    let indexForleadSource = this.filterSelectObj.findIndex(x => x.property == 'sourceName')
    if (indexForleadSource > -1) {
      this.getLeadSourceDownList();
    }

    let indexFortracker = this.filterSelectObj.findIndex(x => x.property == 'tracker')
    if (indexFortracker > -1) {
      this.getAllTracker();
    }

    let indexForPriority = this.filterSelectObj.findIndex(x => x.property == 'priority')
    if (indexForPriority > -1) {
      this.getpriorityDownList();
    }

    let indexForWarehouse = this.filterSelectObj.findIndex(x => x.property == 'warehouse' || x.name == 'Warehouse' || x.property == 'warehouseName' || x.name == 'Warehouse Name')
    if (indexForWarehouse > -1) {
      this.getAllWareHouseList();
    }

    let indexForBrands = this.filterSelectObj.findIndex(x => x.property == 'brands' || x.name == 'Brands')
    if (indexForBrands > -1) {
      this.getBrandDownList();
      this.BrandYFilter();
    }

    let indexForCategories = this.filterSelectObj.findIndex(x => x.property == 'categoryNames' || x.name == 'Categories')
    if (indexForCategories > -1) {
      this.getCategoryDownList();
      this.CategoryYFilter();
    }

    let indexForStatus = this.filterSelectObj.findIndex(x => x.property == 'status' || x.name == 'Status' || x.property == 'statusName' || x.name == 'Status Name' || x.name == 'Lead Status')
    if (indexForStatus > -1) {
      this.getLeadDropDownList();
    }

    let indexForTypeOfService = this.filterSelectObj.findIndex(x => x.name == 'Type of Service')
    if (indexForTypeOfService > -1) {
      this.getPaymentList();
    }

    // Industry Type dropdown
    let indexForIndustry = this.filterSelectObj.findIndex(x => x.name == 'Industry Type' || x.property == 'industryType');
    if (indexForIndustry > -1) {
      this.getAllIndustry();
      this.IndustryYFilter();
    }

    // Business Type dropdown
    let indexForBusiness = this.filterSelectObj.findIndex(x => x.name == 'Busniess Type' || x.property == 'businessType');
    if (indexForBusiness > -1) {
      this.getAllBusiness();
      this.BusinessYFilter();
    }


    let indexForleadUser = this.filterSelectObj.findIndex(x =>
      x.name == 'User Name' ||
      x.property == 'createdBy' ||
      x.property == 'created_by' ||
      x.property == 'a.created_by' ||
      x.property == 'ownerEmail' ||
      x.property == 'a.user_name' ||
      x.property == 'a.owner_id' ||
      x.name == 'Owner' ||
      x.name == 'Created By'
    );
    if (indexForleadUser > -1) {
      this.getUserDropDownList();
    }
    let indexForleadActivity = this.filterSelectObj.findIndex(x => x.name == 'Activity Type')
    if (indexForleadActivity > -1) {
      this.getLeadActivityTypeDownList();
    }

    let indexForTags = this.filterSelectObj.findIndex(x => x.name == 'Tags')
    if (indexForTags > -1) {
      this.getAllTags();
    }


    indexForTags = this.filterSelectObj.findIndex(x => x.property == 'tagName')
    if (indexForTags > -1) {
      this.getAllTags();
    }

    if (this.router.url.includes('googleCalender')) {
      this.displayOwner = true;
    }

    if (this.displayOwner) {

      let indexForleadUserOwner = this.filterSelectObj.findIndex(x => x.property == 'ownerEmail')
      if (indexForleadUserOwner > -1) {
        this.getUserDropDownList();
      }

      indexForleadUserOwner = this.filterSelectObj.findIndex(x => x.property == 'a.owner_id')
      if (indexForleadUserOwner > -1) {
        this.getUserDropDownList();
      }


      if (indexForleadUserOwner < 0) {
        let indexForleadUserOwnerNew = this.filterSelectObj.findIndex(x => x.name == 'Owner')
        if (indexForleadUserOwnerNew > -1) {
          this.getUserDropDownList();
        }
      }

    }


    let indexForDealStage = this.filterSelectObj.findIndex(x => x.name == 'Stage' || x.name == 'Stage Name' || x.name == 'Deal Stage')
    if (indexForDealStage > -1) {
      this.getDealStage();
    }

    if (this.refreshRequired == undefined) {
      this.refreshRequired = false;
    }

    if (this.searchRequired == undefined) {
      this.searchRequired = true;
    }
    if (this.displayColumnRequired == undefined) {
      this.displayColumnRequired = true;
    }
    fromEvent(this.filter.nativeElement, 'keyup').pipe(
      distinctUntilChanged(),
      debounceTime(150)
    ).subscribe((e) => {

      let value = (<HTMLInputElement>e['target']).value;

      if (e['code'] == 'Space' && value == ' ') {
        if (this.searchTermMainPresent) {
          this.searchTermMainPresent = true;
        }
        this.filter.nativeElement.value = this.filter.nativeElement.value.trim()
      } else if (e['key'] == 'Backspace') {
        this.searchTermMain = this.filter.nativeElement.value;
        if (this.searchTermMainEmit == 0 && this.searchTermMain.trim().length == 0) {
          this.searchTermMainPresent = true;
        } else {
          this.searchTermMainPresent = false;
        }

        //  this.filterChange.emit(this.filter.nativeElement.value.trim())
      }
      else if (e['code'] != 'Space' && value.trim().length == 0) {
        value = value.trim();
      }
      else if (value.trim().length > 0) {
        this.searchTermMainPresent = false;
        this.searchTermMain = this.filter.nativeElement.value;
        // this.filterChange.emit(this.filter.nativeElement.value.trim())
      }
    });

    this.modelChanged
      .pipe(
        debounceTime(150))
      .subscribe((event) => {

        let value = (<HTMLInputElement>this.searchValues['target']).value;
        let code = this.searchValues['code'];
        if (code == 'Space' && value == ' ') {
          value = value.trim();
        } else if (code == 'Backspace') {
          this.filterColumnText(value, this.index, this.j)
          if (this.searchTermEmit == 0 && this.searchTerm == undefined) {
            this.searchTermPresent = true;

          } else {
            this.searchTermPresent = false;
          }

        }
        else if (code != 'Space' && value.trim().length == 0) {
          value = value.trim();
        }
        else if (value.trim().length > 0) {
          this.filterColumnText(value, this.index, this.j)
        }
      })
    // console.log(this.filterSelectObj);

    this.init = true;
  }

  private formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }


  filtersForm: UntypedFormGroup;
  initializeForm(): void {
    this.filtersForm = this._formBuilder.group({
      ranges: this._formBuilder.array([])
    });

    this.addDateRangeFormGroup();
  }
  addDateRangeFormGroup(): void {
    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    let range = JSON.parse(localStorage.getItem(cleanUrl + "range") || 'null');
    let filterObject = JSON.parse(localStorage.getItem(cleanUrl) || 'null');

    if (!filterObject) {
      filterObject = [];
    } else {
      this.filterSelectObj = filterObject;
    }

    let indexValue = 0;

    // Ensure filtersForm is initialized
    if (!this.filtersForm) {
      this.filtersForm = this._formBuilder.group({
        ranges: this._formBuilder.array([]) // Initialize ranges as a FormArray
      });
    }

    this.filterSelectObj.forEach((element: any) => {
      let start: any = '';
      let end: any = '';

      if (range && range.ranges && range.ranges[indexValue]) {
        if (range.ranges[indexValue].start != null) {
          start = new Date(range.ranges[indexValue].start);
          end = new Date(range.ranges[indexValue].end);
        }
      }

      const rangeGroup = this._formBuilder.group({
        start: start,
        end: end
      });

      (this.filtersForm?.get('ranges') as FormArray)?.push(rangeGroup);

      // if (filterObject[indexValue] && filterObject[indexValue].modelValue !== undefined) {
      //     element.modelValue = filterObject[indexValue].modelValue;
      // }

      indexValue++;
    });

    // console.log(this.filterSelectObj);
  }


  modelChanged = new Subject<string>();
  search(value, index, j) {
    this.searchValues = value;
    this.index = index;
    this.j = j;

  }



  onPaste(event: ClipboardEvent, index, j) {
    let clipboardData = event.clipboardData
    let pastedText = clipboardData.getData('text');
    let obj = {
      data: pastedText,
      inputType: "Text"
    }
    this.filterColumn(obj, index, pastedText)

  }

  // toggleColumnVisibility(column, event,index) {


  //   event.stopPropagation();
  //   event.stopImmediatePropagation();


  //   column.visible = !column.visible;
  //   this.columns[index].visible = !this.columns[index].visible; 

  //   console.log(this.columns[index].visible);


  // }

  toggleColumnVisibility(column, event, index) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    column.visible = !column.visible;
    this.columns[index].visible = !this.columns[index].visible;
  }


  setValue(index: any, checked) {
    // console.log(this.columns[index].visible);

    event.stopPropagation();
    event.stopImmediatePropagation();

  }

  resetFilters() {
    this.searchTermMain = ''
    if (this.type == 1) {

      this.filter.nativeElement.value = '';
    }

    this.filtersForm.reset();
    this.filterSelectObj.forEach((value, key) => {
      value.modelValue = undefined;
      this[value.position] = undefined
    })
    this.selected = 'ALL'
    this.searchTerm = null;
    this.searchTerm = undefined;

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    localStorage.removeItem(cleanUrl);
    localStorage.removeItem(cleanUrl + "se"); localStorage.removeItem(cleanUrl + "select");
    localStorage.removeItem(cleanUrl + "type");
    localStorage.removeItem(cleanUrl + "range");
    localStorage.removeItem("advanceFilterConditionsText");
    localStorage.removeItem("advanceFilterEnble");
    localStorage.removeItem("advanceFilterConditions");
    this.filterChangeColumn.emit(this.searchTerm)
    this.selectedValues = [];
  }

  @Input() rangeactive: any = 0;
  @Input() updatedDateRange: number;
  @Input() updatedIndex: number;

  previousDateRange: number;  // Store the previous value of updatedDateRange

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['updatedDateRange'] || changes['updatedIndex']) {
      // console.log('Updated Date Range:', this.updatedDateRange);
      // console.log('Updated Index:', this.updatedIndex);
    }
    // Check if the 'updatedDateRange' has changed
    if (changes['updatedDateRange'] && changes['updatedDateRange'].currentValue !== this.previousDateRange) {
      // Update the previousDateRange to the new value
      this.previousDateRange = changes['updatedDateRange'].currentValue;

      // Call the function only if the value has actually changed
      this.onRangeSelected(this.updatedDateRange, 1);
    }

    if (changes['filterSelectObj']) {



      let url = this.router.url;
      this.filterSelectObj = changes['filterSelectObj'].currentValue
      let cleanUrl = url.split('?')[0];
      let range = JSON.parse(localStorage.getItem(cleanUrl + "range") || 'null');
      this.filterSelectObj.forEach((element: any) => {
        let start: any = '';
        let end: any = '';


        let indexValue = 0;

        if (range && range.ranges && range.ranges[indexValue]) {
          if (range.ranges[indexValue].start != null) {
            start = new Date(range.ranges[indexValue].start);
            end = new Date(range.ranges[indexValue].end);
          }
        }

        const rangeGroup = this._formBuilder.group({
          start: start,
          end: end
        });

        (this.filtersForm?.get('ranges') as FormArray)?.push(rangeGroup);

        indexValue++;
      });

      // console.log(this.filtersForm);
      if (this.filterSelectObj.length > 0) {

        let indexForleadStatus = this.filterSelectObj.findIndex(x => x.name == 'Status Name')
        if (indexForleadStatus > -1) {
          this.getLeadDropDownList();
        } else {
          indexForleadStatus = this.filterSelectObj.findIndex(x => x.property == 'statusName')
          if (indexForleadStatus > -1) {
            this.getLeadDropDownList();
          } else {
            indexForleadStatus = this.filterSelectObj.findIndex(x => x.property == 'c.status_name' || x.name == 'Lead Status' || x.property == 'status' || x.name == 'Status')
            if (indexForleadStatus > -1) {
              this.getLeadDropDownList();
            }
          }


        }


        let indexForleadStage = this.filterSelectObj.findIndex(x => x.name == 'Stage' || x.name == 'Life Stage')
        if (indexForleadStage > -1) {
          this.getLeadDropDownList();
        }


        let indexForleadSource = this.filterSelectObj.findIndex(x => x.name == 'Source Name')
        if (indexForleadSource > -1) {
          this.getLeadSourceDownList();
        } else {
          indexForleadSource = this.filterSelectObj.findIndex(x => x.property == 'sourceName')
          if (indexForleadSource > -1) {
            this.getLeadSourceDownList();
          } else {
            indexForleadSource = this.filterSelectObj.findIndex(x => x.property == 'g.source_name' || x.name == 'Lead Source')
            if (indexForleadSource > -1) {
              this.getLeadSourceDownList();
            }
          }
        }


        let indexForTypeOfService = this.filterSelectObj.findIndex(x => x.name == 'Type of Service')
        if (indexForTypeOfService > -1) {
          this.getPaymentList();
        }

        let indexForleadUser = this.filterSelectObj.findIndex(x =>
          x.name == 'User Name' ||
          x.property == 'createdBy' ||
          x.property == 'created_by' ||
          x.property == 'a.created_by' ||
          x.property == 'ownerEmail' ||
          x.property == 'a.user_name' ||
          x.property == 'a.owner_id' ||
          x.name == 'Owner' ||
          x.name == 'Created By'
        );
        if (indexForleadUser > -1) {
          this.getUserDropDownList();
        }
        let indexForleadActivity = this.filterSelectObj.findIndex(x => x.name == 'Activity Type')
        if (indexForleadActivity > -1) {
          this.getLeadActivityTypeDownList();
        }

        let indexFortracker = this.filterSelectObj.findIndex(x => x.property == 'tracker')
        if (indexFortracker > -1) {
          this.getAllTracker();
        }

        let indexForPriority = this.filterSelectObj.findIndex(x => x.property == 'priority')
        if (indexForPriority > -1) {
          this.getpriorityDownList();
        }

      }




    }




  }



  dateRangeOptions = [
    { label: 'Last 10 Days', value: 10 },
    { label: 'Last 20 Days', value: 20 },
    { label: 'Last 30 Days', value: 30 },
  ];
  selectedRange = this.dateRangeOptions[0].value;

  onRangeSelected(days: number, index: number): void {
    if (!this.filtersForm) {
      this.initializeForm();
    }
    const currentDate = new Date();
    const startDate = new Date();
    startDate.setDate(currentDate.getDate() - days);

    // Format dates using the existing datepipe
    const formattedStart = this.datepipe.transform(startDate, 'yyyy-MM-dd');
    const formattedEnd = this.datepipe.transform(currentDate, 'yyyy-MM-dd');

    // Update the filtersForm values
    const ranges = this.filtersForm?.get('ranges') as FormArray;
    if (ranges && ranges.at && ranges.length > index && ranges.at(index)) {
      ranges.at(index).patchValue({
        start: formattedStart,
        end: formattedEnd,
      });
    }

    // Reuse the existing logic
    if (this.filterSelectObj && this.filterSelectObj[index]) {
      this.start({ value: formattedStart }, 'start', index);
      this.end({ value: formattedEnd }, 'end', index);
      this.searchFilter();
    }
  }


  resetFiltersMobiletest() {
    this.searchTermMain = ''
    if (this.type == 1) {

      this.filter.nativeElement.value = '';
    }

    this.filtersForm.reset();
    this.filterSelectObj.forEach((value, key) => {
      value.modelValue = undefined;
      this[value.position] = undefined
    })
    this.selected = 'ALL'
    this.searchTerm = null;
    this.searchTerm = undefined;

    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    localStorage.removeItem(cleanUrl);
    localStorage.removeItem(cleanUrl + "se"); localStorage.removeItem(cleanUrl + "select");
    localStorage.removeItem(cleanUrl + "type");
    localStorage.removeItem(cleanUrl + "range");
    localStorage.removeItem("advanceFilterConditionsText");
    localStorage.removeItem("advanceFilterEnble");
    localStorage.removeItem("advanceFilterConditions");

    this.filterChangeColumn.emit(this.searchTerm)
    this.selectedValues = [];
  }


  filterColumnText(value, index, j) {

    // console.log(value);


    // console.log((<HTMLInputElement>value['target']).value + 'sa')
    if (value.code == 'Space' && (<HTMLInputElement>value['target']).value.length > 0) {

      (<HTMLInputElement>value['target']).value = (<HTMLInputElement>value['target']).value + Array(1).fill('\xa0').join('')
    }

    let finalValue = (<HTMLInputElement>value['target']).value;


    // console.log(finalValue + "sas");
    if (finalValue.trim().length > 0) {



      this.searchValues = value;
      if (value.code == 'Space' && (<HTMLInputElement>value['target']).value.trim().length > 0) {

        (<HTMLInputElement>value['target']).value = (<HTMLInputElement>value['target']).value = (<HTMLInputElement>value['target']).value + Array(1).fill('\xa0').join('')
      }
      let finalValue = (<HTMLInputElement>value['target']).value;


      // console.log(finalValue + "sas");
      if (this[this.filterSelectObj[index].position] == null) {

        this[this.filterSelectObj[index].position] = finalValue != null ? finalValue : finalValue;

      }
      else {

        if (finalValue != undefined) {

          if (finalValue.length == 0) {
            this[this.filterSelectObj[index].position] = undefined;
          } else {
            this[this.filterSelectObj[index].position] = finalValue;
          }

        }
        else if (j.length == 0) {
          this[this.filterSelectObj[index].position] = undefined;
        }
        else if (this[this.filterSelectObj[index].position] != ''
          && this.filterSelectObj[index].type != 'select'
          && this[this.filterSelectObj[index].position].length > 1) {
          this[this.filterSelectObj[index].position] = this[this.filterSelectObj[index].position].slice(0, -1);
        }
        else {
          this[this.filterSelectObj[index].position] = undefined;
        }

      }


    } else {

      this[this.filterSelectObj[index].position] = undefined;
    }
    this.filterOutput();
  }

  filterColumn(value, index, j) {
    let finalValue = value.value;

    if (finalValue === 'ALL' || finalValue === undefined || finalValue === null) {
      this[this.filterSelectObj[index].position] = undefined;
    } else {
      this[this.filterSelectObj[index].position] = finalValue;
    }

    this.filterOutput();
  }

  selectedValues: any[] = [];
  filterColumnMultiSelect(value, index, j) {
    if (value && value.value && value.value.length > 0) {
      this[this.filterSelectObj[index].position] = value.value.join(',');
    } else {
      this[this.filterSelectObj[index].position] = undefined;
    }

    this.filterOutput();
  }


  filterOutput() {

    this.searchTerm = undefined;
    this.filterSelectObj.forEach((element, indexForLoop) => {
      //   console.log(this.filterSelectObj[indexForLoop].type)
      if (this[element['position']] != undefined) {
        if (this.searchTerm == undefined) {

          if (this.filterSelectObj[indexForLoop].type == 'price') {
            this.searchTerm = this.filterSelectObj[indexForLoop].property + ':' + this[element['position']];
          }
          else if (this.filterSelectObj[indexForLoop].type == 'time') {
            let val12 = this.convertTo12Hour(this[element['position']]);
            this.searchTerm = this.filterSelectObj[indexForLoop].property + ':' + "'*" + val12 + "*'"
          }
          else if (this.filterSelectObj[indexForLoop].type != 'select') {
            this.searchTerm = this.filterSelectObj[indexForLoop].property + ':' + "'*" + this[element['position']] + "*'"
          }
          else if (this.filterSelectObj[indexForLoop].type == 'select') {

            let selectVal = this[element['position']];
            if (typeof selectVal === 'string' && selectVal.includes(' ')) {
              this.searchTerm = this.filterSelectObj[indexForLoop].property + ':' + "'" + selectVal + "'"
            } else {
              this.searchTerm = this.filterSelectObj[indexForLoop].property + ':' + selectVal;
            }

          }
        }
        else {

          if (this.filterSelectObj[indexForLoop].type == 'price') {
            this.searchTerm = this.searchTerm + ' AND ' + this.filterSelectObj[indexForLoop].property + ':' + this[element['position']];
          }
          else if (this.filterSelectObj[indexForLoop].type == 'time') {
            let val12 = this.convertTo12Hour(this[element['position']]);
            this.searchTerm = this.searchTerm + ' AND ' + this.filterSelectObj[indexForLoop].property + ':' + "'*" + val12 + "*'"
          }
          else if (this.filterSelectObj[indexForLoop].type != 'select') {
            this.searchTerm = this.searchTerm + ' AND ' + this.filterSelectObj[indexForLoop].property + ':' + "'*" +
              this[element['position']] + "*'"
          } else {
            let selectVal = this[element['position']];
            if (typeof selectVal === 'string' && selectVal.includes(' ')) {
              this.searchTerm = this.searchTerm + ' AND ' + this.filterSelectObj[indexForLoop].property + ':' + "'" + selectVal + "'"
            } else {
              this.searchTerm = this.searchTerm + ' AND ' + this.filterSelectObj[indexForLoop].property + ':' + selectVal
            }
          }
        }

      }

    });

    this.searchTermPresent = false;

  }

  start(event, type, index) {
    event.value = this.datepipe.transform(event.value, 'yyyy-MM-dd');
    let startDate = event.value;

    this[this.filterSelectObj[index].position] = startDate;

    let stringToSplit = this[this.filterSelectObj[index].position].split("~");

    // console.log(this.filtersForm);

  }


  end(event, type, index) {

    event.value = this.datepipe.transform(event.value, 'yyyy-MM-dd');
    let endDate = event.value;


    if (this.filtersForm.value.ranges[index] != null && this.filtersForm.value.ranges[index] != null && endDate != null) {
      // Find the index of the first tilde
      const tildeIndex = this[this.filterSelectObj[index].position].indexOf('~');

      // If a tilde is found, replace everything after it
      this[this.filterSelectObj[index].position] = tildeIndex === -1
        ? this[this.filterSelectObj[index].position]
        : this[this.filterSelectObj[index].position].substring(0, tildeIndex + 1);
      this[this.filterSelectObj[index].position] = this[this.filterSelectObj[index].position].replace(/~/g, '');;
      this[this.filterSelectObj[index].position] = this[this.filterSelectObj[index].position] + '~' + endDate;
      this.selectedValuesDate[this.filterSelectObj[index].position] = this[this.filterSelectObj[index].position];
      this.filterOutput();
    }
    // console.log(this.filtersForm);

  }


  searchFilter() {

    if (!this.searchTermPresent) {
      if (this.searchTerm == undefined) {
        this.searchTermPresent = true;
        this.searchTermEmit = 0
      } else {
        this.searchTermPresent = false;
        this.searchTermEmit++;
      }

      var rule = /\s{1,}/g;

      if (this.searchTerm != undefined) {
        this.searchTerm = this.searchTerm.split(rule).join(" ");
      }

      if (this.router.url.includes('lead') && this.name == 'Lead') {
        let url = this.router.url;
        let cleanUrl = url.split('?')[0];

        if (this.type == 1) {

          localStorage.removeItem("advanceFilterConditionsText");

          localStorage.removeItem("advanceFilterConditions");

          localStorage.removeItem("advanceFilterEnble");

          localStorage.removeItem(cleanUrl);
          localStorage.setItem(cleanUrl, JSON.stringify(this.filterSelectObj));
          localStorage.setItem(cleanUrl + "se", this.searchTerm);
          localStorage.setItem(cleanUrl + "type", "2");

          localStorage.setItem(cleanUrl + "range", JSON.stringify(this.filtersForm.value));

          localStorage.setItem(cleanUrl + "selected", JSON.stringify(this.selectedValues));


          localStorage.setItem(cleanUrl + "selectedDate", JSON.stringify(this.selectedValuesDate));

        }


      }

      if (this.router.url.includes('deals') && this.name == 'Deal') {
        let url = this.router.url;
        let cleanUrl = url.split('?')[0];

        if (this.type == 1) {

          localStorage.removeItem("advanceFilterConditionsText");

          localStorage.removeItem("advanceFilterConditions");

          localStorage.removeItem("advanceFilterEnble");
          localStorage.removeItem(cleanUrl);
          localStorage.setItem(cleanUrl, JSON.stringify(this.filterSelectObj));
          localStorage.setItem(cleanUrl + "se", this.searchTerm);
          localStorage.setItem(cleanUrl + "type", "2");

          localStorage.setItem(cleanUrl + "range", JSON.stringify(this.filtersForm.value));

          localStorage.setItem(cleanUrl + "selected", JSON.stringify(this.selectedValues));


          localStorage.setItem(cleanUrl + "selectedDate", JSON.stringify(this.selectedValuesDate));

        }


      }

      localStorage.removeItem("advanceFilterConditionsText");
      localStorage.removeItem("advanceFilterEnble");
      localStorage.removeItem("advanceFilterConditions");

      this.filterChangeColumn.emit(this.searchTerm)

    } else {
      this.searchTermEmit = 0;
      this.searchTermPresent = true;
    }
  }


  searchFilterMain() {

    if (!this.searchTermMainPresent) {
      if (this.searchTermMain.trim().length == 0) {
        this.searchTermMainPresent = true;
        this.searchTermMainEmit = 0
      } else {
        this.searchTermMainPresent = false;
        this.searchTermMainEmit++;
        let url = this.router.url;
        let cleanUrl = url.split('?')[0];
        localStorage.removeItem(cleanUrl);
        localStorage.removeItem(cleanUrl + "type");
        localStorage.setItem(cleanUrl + "se", this.searchTermMain);
        localStorage.setItem(cleanUrl + "type", "2");
        localStorage.removeItem("advanceFilterConditionsText");
        localStorage.removeItem("advanceFilterEnble");
        localStorage.removeItem("advanceFilterConditions");

      }

      this.filterChange.emit(this.searchTermMain)

    } else {
      this.searchTermMainEmit = 0;
      this.searchTermMainPresent = true;
    }
  }

  mobileSearch() {
    let value = this.value.value;


    this.searchTermMain = value;
    this.searchTermMainPresent = false;

    this.searchFilterMain()

  }

  resetFiltersMobile() {

    this.value.reset();
    this.filter.nativeElement.value = '';
    this.resetFiltersMobiletest()
    this.selectedValues = [];
    localStorage.removeItem("advanceFilterConditionsText");
    localStorage.removeItem("advanceFilterEnble");
    localStorage.removeItem("advanceFilterConditions");
  }

  createRangeForm() {
    this.range = this._formBuilder.group({
      start: [''],
      end: [''],



    },


    )
  }


  //lead status

  filtereddropdownTypeList: any;

  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();
  protected _onDestroy = new Subject<void>();

  defaultLeadStatus: FormControl = new FormControl('');

  dropdownTypeList: any;
  dropdownList: any;


  getLeadDropDownList() {
    let cleanUrl = this.router.url.split('?')[0];
    if (this.name == 'Tasks' || cleanUrl.includes('tasks') || cleanUrl.includes('Tasks')) {
      this.taskStatusService.getAlltaskStatusDropDown(8).subscribe(
        res => {
          this.dropdownList = res;
          this.dropdownTypeList = res;
          this.filtereddropdownTypeList = this.dropdownTypeList;
        },
        error => {
        })
      this.typeYFilter();
      this.getAlldropdowntype();
    } else {
      this.leadStatusService.getAllLeadStatusDropDown(0).subscribe(
        res => {
          this.dropdownList = res;
          this.dropdownTypeList = res;
          this.filtereddropdownTypeList = this.dropdownTypeList;
        },
        error => {
        })
    }
  }


  typeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidYFilter();
      });
  }


  protected typeidYFilter() {
    if (!this.dropdownTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereddropdownTypeList = this.dropdownTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereddropdownTypeList = this.dropdownTypeList.filter(user => user['statusName'].toLowerCase().indexOf(search) > -1)
  }

  getAlldropdowntype() {
    this.filtereddropdownTypeList = this.dropdownTypeList;
  }


  //leadSource

  filteredLeadSourceTypeList: any;

  LeadSourceTypeList: any;
  LeadSourceList: any;

  getLeadSourceDownList() {

    this.leadSourceService.getAllLeadSourceDropDown().subscribe(
      res => {
        this.LeadSourceList = res;
        this.LeadSourceTypeList = res;
        this.filteredLeadSourceTypeList = this.LeadSourceTypeList;
      },
      error => {
      })
  }


  LeadSourceYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeLeadSourceYFilter();
      });
  }


  protected typeLeadSourceYFilter() {
    if (!this.LeadSourceTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredLeadSourceTypeList = this.LeadSourceTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredLeadSourceTypeList = this.LeadSourceTypeList.filter(source => source['sourceName'].toLowerCase().indexOf(search) > -1)
  }

  getAllSourcedropdowntype() {
    this.filteredLeadSourceTypeList = this.LeadSourceTypeList;
  }

  //taskStatus

  filteredTaskStatusTypeList: any;

  TaskStatusTypeList: any;
  TaskStatusList: any;

  getTaskStatusDownList() {

    this.taskStatusService.getAlltaskStatusDropDown(8).subscribe(
      res => {
        this.TaskStatusList = res;
        this.TaskStatusTypeList = res;
        this.filteredTaskStatusTypeList = this.TaskStatusTypeList;
      },
      error => {
      })
    this.TaskStatusYFilter();
    this.getAllTaskStatusdropdowntype();
  }


  TaskStatusYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeTaskStatusYFilter();
      });
  }


  protected typeTaskStatusYFilter() {
    if (!this.TaskStatusTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredTaskStatusTypeList = this.TaskStatusTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredTaskStatusTypeList = this.TaskStatusTypeList.filter(source => source['statusName'].toLowerCase().indexOf(search) > -1)
  }

  getAllTaskStatusdropdowntype() {
    this.filteredTaskStatusTypeList = this.TaskStatusTypeList;
  }

  //ActivityType

  filteredActivityTypeList: any;

  LeadActivityTypeList: any;
  LeadActivityList: any;

  getLeadActivityTypeDownList() {

    this.leadSourceService.getAllActivityTypeDropDown().subscribe(
      res => {
        this.LeadActivityList = res;
        this.LeadActivityTypeList = res;
        this.filteredActivityTypeList = this.LeadActivityTypeList;
      },
      error => {
      })
  }


  LeadActivityTypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeLeadActivityTypeYFilter();
      });
  }


  protected typeLeadActivityTypeYFilter() {
    if (!this.LeadActivityTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredActivityTypeList = this.LeadActivityTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredActivityTypeList = this.LeadActivityTypeList.filter(source => source['activityType'].toLowerCase().indexOf(search) > -1)
  }

  getAllActivityTypedropdowntype() {
    this.filteredActivityTypeList = this.LeadActivityTypeList;
  }




  //user Group

  defaultLeadOwner: FormControl = new FormControl('');

  userTypeList: any;
  userList: any;
  filtereduserTypeList: any;

  getUserDropDownList() {

    let userType: any = localStorage.getItem(Constant.Sup);

    let val: any = localStorage.getItem('userType')

    if (val == 'salesUser' || userType === 'Sales User') {
      val = 1;
    } else {
      val = 0;
    }

    if (!this.router.url.includes('crmAnalytics') && val == 0) {

      this.usersService.getAllUserStatusDropDown().subscribe(
        res => {
          this.userList = res;
          this.userTypeList = res;
          this.filtereduserTypeList = this.userTypeList;
        },
        error => {
        })
    } else {
      this.usersService.getAllUserStatusDropDownSales().subscribe(
        res => {
          this.userList = res;
          this.userTypeList = res;
          this.filtereduserTypeList = this.userTypeList;
        },
        error => {
        })
    }

  }

  usertypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.usertypeidYFilter();
      });
  }


  protected usertypeidYFilter() {
    if (!this.userTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }

  close() {
    this.filterOpen = false;
  }

  openNew() {
    this.filterOpen = true;
  }


  openNew1() {
    this.isPopupOpen = true;
  }


  closePopup(event) {
    if (event == true) {
      this.isPopupOpen = false;

    }
  }


  handleFilterApplied(event: any) {

    // console.log("search" , event);
    this.filterChangeColumn.emit(event)

  }

  handleFilterReset(event) {
    // console.log('Filters reset');

    this.filterChangeColumn.emit(this.searchTerm)

  }

  //paidBy

  paymentList: any;
  paymentTypeList: any;
  filteredPayemntTypeList: any;

  public paymentFilterControl: UntypedFormControl = new UntypedFormControl();

  getPaymentList() {
    this.paymentTypeService.getAllPaymentModeDropDown().subscribe(
      res => {
        this.paymentList = res;
        this.paymentTypeList = res;
        this.filteredPayemntTypeList = this.paymentTypeList;

      },
      () => {
      })
  }


  PaymentYFilter() {
    this.paymentFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.paymentFilter();
      });
  }


  protected paymentFilter() {
    if (!this.paymentTypeList) {
      return;
    }
    // get the search keyword
    let search = this.paymentFilterControl.value;
    if (!search) {
      this.filteredPayemntTypeList = this.paymentTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredPayemntTypeList = this.paymentTypeList.filter(bank => bank['name']
      .toLowerCase().indexOf(search) > -1)
  }

  getAllPaymentSet() {
    this.filteredPayemntTypeList = this.paymentTypeList;
  }
  supplierList: any = [];
  supplierTypeList: any = [];
  filteredsupplierTypeList: any = [];
  supplierControl: UntypedFormControl = new UntypedFormControl();
  supplierFilterControl: UntypedFormControl = new UntypedFormControl();
  options: any;



  getAllsupplier() {
    this.filteredsupplierTypeList = this.supplierTypeList;
  }

  supplierYFilter() {
    this.supplierFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.supplierFilter();
      });
  }

  getAllSupplierList() {

    this.posSupplierService.getAllsupplierDropDown().subscribe(
      data => {
        this.supplierList = data;

        this.supplierTypeList = data;
        this.filteredsupplierTypeList = this.supplierTypeList;

      }
    )

    this.supplierYFilter();
    this.getAllsupplier();
  }

  protected supplierFilter() {
    if (!this.supplierTypeList) {
      return;
    }
    // get the search keyword
    let search = this.supplierFilterControl.value;
    if (!search) {
      this.filteredsupplierTypeList = this.supplierTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredsupplierTypeList = this.supplierTypeList.filter(supplier => supplier['name'].toLowerCase().indexOf(search) > -1)
  }

  //warehouse
  warehouseList: any = [];
  warehouseTypeList: any = [];
  filteredWarehouseTypeList: any = [];
  warehouseControl: UntypedFormControl = new UntypedFormControl();
  warehouseFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllWareHouseList() {

    this.poswarehouseService.getAllWarehouseDropDown().subscribe(
      data => {
        this.warehouseList = data;


        // this.warehouseList.push(object);

        this.warehouseTypeList = data;
        this.filteredWarehouseTypeList = this.warehouseTypeList;

      }
    )

    this.warehouseYFilter();
    this.getAllWarehouse();
  }


  getAllWarehouse() {
    this.filteredWarehouseTypeList = this.warehouseTypeList;
  }

  warehouseYFilter() {
    this.warehouseFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.warehouseFilter();
      });
  }

  protected warehouseFilter() {
    if (!this.warehouseTypeList) {
      return;
    }
    // get the search keyword
    let search = this.warehouseFilterControl.value;
    if (!search) {
      this.filteredWarehouseTypeList = this.warehouseTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredWarehouseTypeList = this.warehouseTypeList.filter(Warehouse => Warehouse['name'].toLowerCase().indexOf(search) > -1)
  }


  //stagr


  getDealStage() {

    this.dealsStageService.getAllDealsStagesDropDown(4).subscribe(
      res => {

        this.dealStatusList = res;
        this.dealStatusTypeList = res;
        this.filteredlDealStatusTypeList = this.dealStatusTypeList;

        console.log(this.dealStatusList);


      },
      error => {
      }
    )
    this.LeadStatusYFilter();
    this.getLeadStatusList();
  }

  //lead status

  dealStatusList: any;
  dealStatusTypeList: any;
  filteredlDealStatusTypeList: any;

  public dealStatusFilterControl: UntypedFormControl = new UntypedFormControl();

  getLeadStatusList() {

    this.filteredlDealStatusTypeList = this.dealStatusTypeList;
  }

  LeadStatusYFilter() {
    this.dealStatusFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.LeadStatusFilter();
      });
  }


  protected LeadStatusFilter() {
    if (!this.dealStatusTypeList) {
      return;
    }
    // get the search keyword
    let search = this.dealStatusFilterControl.value;
    if (!search) {
      this.filteredlDealStatusTypeList = this.dealStatusTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredlDealStatusTypeList = this.dealStatusTypeList.filter(status => status['statusName']
      .toLowerCase().indexOf(search) > -1)
  }


  openBusinessEditDialog(): void {
    const dialogRef = this.dialog.open(CrmBusinessEditComponent, {
      width: '800px',
      // height: '600px', 
      panelClass: 'business-edit-dialog',
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result['event'] == 'add') {
        window.location.reload();
        console.log("here dialog close");

      }
    });
  }


  //Tags

  tagsList: any = [];
  tagsTypeList: any = [];
  filteredtagsTypeList: any = [];
  tagsControl: UntypedFormControl = new UntypedFormControl();
  tagsFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllTags() {
    this.tagesStatusService.getAllTagsDropDown(5).subscribe(
      data => {
        this.tagsList = data;
        this.tagsTypeList = data;
        this.filteredtagsTypeList = this.tagsTypeList;
      },
      error => {
      }
    )
  }

  TagsYFilter() {
    this.tagsFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.tagsFilter();
      });
  }

  protected tagsFilter() {
    if (!this.tagsTypeList) {
      return;
    }
    // get the search keyword
    let search = this.tagsFilterControl.value;
    if (!search) {
      this.filteredtagsTypeList = this.tagsTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredtagsTypeList = this.filteredtagsTypeList.filter(tags => tags['statusName'].toLowerCase().indexOf(search) > -1)
  }

  //Priority

  filteredPriorityTypeList: any;
  priorityTypeList: any;
  priorityList: any;
  PriorityFilterControl: UntypedFormControl = new UntypedFormControl();

  getpriorityDownList() {

    this.priorityService.getAllPriorityDropDown().subscribe(
      data => {
        this.priorityList = data;
        this.priorityTypeList = data;
        console.log("here");

        this.filteredPriorityTypeList = this.priorityTypeList;
      },
      error => {
      }
    )
  }


  PriorityYFilter() {
    this.PriorityFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.priorityFilter();
      });
  }


  protected priorityFilter() {
    if (!this.priorityTypeList) {
      return;
    }
    // get the search keyword
    let search = this.PriorityFilterControl.value;
    if (!search) {
      this.filteredPriorityTypeList = this.priorityTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredPriorityTypeList = this.filteredPriorityTypeList.filter(priority => priority['priorityName'].toLowerCase().indexOf(search) > -1)
  }

  // Brands
  getBrandDownList() {
    this.brandService.getAllBrandDropDown().subscribe(
      data => {
        this.brandList = data;
        this.brandTypeList = data;
        this.filteredBrandTypeList = this.brandTypeList;
      },
      error => {
      }
    );
  }

  BrandYFilter() {
    this.BrandFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.brandFilter();
      });
  }

  protected brandFilter() {
    if (!this.brandTypeList) {
      return;
    }
    let search = this.BrandFilterControl.value;
    if (!search) {
      this.filteredBrandTypeList = this.brandTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredBrandTypeList = this.brandTypeList.filter(b => b.name.toLowerCase().indexOf(search) > -1);
  }

  // Categories
  getCategoryDownList() {
    this.categoriesService.getAllCategoriesDropDown().subscribe(
      data => {
        this.categoryList = data;
        this.categoryTypeList = data;
        this.filteredCategoryTypeList = this.categoryTypeList;
      },
      error => {
      }
    );
  }

  CategoryYFilter() {
    this.CategoryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.categoryFilter();
      });
  }

  protected categoryFilter() {
    if (!this.categoryTypeList) {
      return;
    }
    let search = this.CategoryFilterControl.value;
    if (!search) {
      this.filteredCategoryTypeList = this.categoryTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredCategoryTypeList = this.categoryTypeList.filter(c => c.name.toLowerCase().indexOf(search) > -1);
  }


  getAllPriority() {
    this.filteredPriorityTypeList = this.priorityTypeList;
  }

  // Tracker

  trackerList: any = [];
  trackerTypeList: any = [];
  filteredTrackerTypeList: any = [];
  trackerControl: UntypedFormControl = new UntypedFormControl();
  trackerFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllTracker() {
    this.trackerService.getAllTrackerDropDown().subscribe(
      data => {
        this.trackerList = data;
        this.trackerTypeList = data;
        this.filteredTrackerTypeList = this.trackerTypeList;
      },
      error => {
      }
    )
  }

  TrackerYFilter() {
    this.trackerFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.trackerFilter();
      });
  }

  protected trackerFilter() {
    if (!this.trackerTypeList) {
      return;
    }
    // get the search keyword
    let search = this.trackerFilterControl.value;
    if (!search) {
      this.filteredTrackerTypeList = this.trackerTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredTrackerTypeList = this.filteredTrackerTypeList.filter(tracker => tracker['trackerName'].toLowerCase().indexOf(search) > -1)
  }

  blockColon(event: KeyboardEvent) {
    if (event.key === ':') {
      event.preventDefault();
    }
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  convertTo12Hour(time: string): string {
    if (!time) {
      return '';
    }
    const [hours, minutes] = time.split(':');
    let h = parseInt(hours, 10);
    const m = minutes;
    const ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12;
    h = h ? h : 12;
    return `${h}:${m} ${ampm}`;
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  // Industry Type
  industryList: any = [];
  industryTypeList: any = [];
  filteredindustryTypeList: any = [];
  industryFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllIndustry() {
    this.industryTypeService.getAllIndustryTypeDropDown(6).subscribe(
      data => {
        this.industryList = data;
        this.industryTypeList = data;
        this.filteredindustryTypeList = this.industryTypeList;
        this.cdr.markForCheck();
      },
      error => {
      }
    )
  }

  IndustryYFilter() {
    this.industryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.industryFilter();
      });
  }

  protected industryFilter() {
    if (!this.industryTypeList) {
      return;
    }
    let search = this.industryFilterControl.value;
    if (!search) {
      this.filteredindustryTypeList = this.industryTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredindustryTypeList = this.industryTypeList.filter(tags => tags['statusName'].toLowerCase().indexOf(search) > -1)
    this.cdr.markForCheck();
  }

  // Business Type
  BusinessList: any = [];
  BusinessTypeList: any = [];
  filteredBusinessTypeList: any = [];
  BusinessFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllBusiness() {
    this.bussinessTypeService.getAllBusinessDropDown(7).subscribe(
      data => {
        this.BusinessList = data;
        this.BusinessTypeList = data;
        this.filteredBusinessTypeList = this.BusinessTypeList;
        this.cdr.markForCheck();
      },
      error => {
      }
    )
  }

  BusinessYFilter() {
    this.BusinessFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.BusinessFilter();
      });
  }

  protected BusinessFilter() {
    if (!this.BusinessTypeList) {
      return;
    }
    let search = this.BusinessFilterControl.value;
    if (!search) {
      this.filteredBusinessTypeList = this.BusinessTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredBusinessTypeList = this.BusinessTypeList.filter(tags => tags['statusName'].toLowerCase().indexOf(search) > -1)
    this.cdr.markForCheck();
  }

  // Generic trackBy function for all ngFor loops in the list component
  // Improves DOM rendering performance significantly
  trackByFn(index: number, item: any): any {
    return item ? (item.id || item._id || item.uuid || index) : index;
  }

}
